// Index of language folders for FamilyWall for i18n plugin of requireJS
import root from "./root/familywall.js?amd";
import fr from "./fr/familywall.js?amd";
import es from "./es/familywall.js?amd";
import de from "./de/familywall.js?amd";
import pt from "./pt/familywall.js?amd";
import sq from "./sq/familywall.js?amd";
import it from "./it/familywall.js?amd";
import nl from "./nl/familywall.js?amd";
import ja from "./ja/familywall.js?amd";
import ru from "./ru/familywall.js?amd";
import ko from "./ko/familywall.js?amd";
import sv from "./sv/familywall.js?amd";

export default {
    // English is defined as "root" to be used as fallback
    root,
    fr,
    es,
    de,
    pt,
    sq,
    nl,
    it,
    ja,
    ru,
    ko,
    sv

  }

